import styled from 'styled-components';
import {
  space,
  SpaceProps,
  typography,
  TypographyProps,
  color,
  ColorProps
} from 'styled-system';

export const StyledDetailsRow = styled.div<SpaceProps>`
  width: 100%;
  position: relative;
  direction: rtl;
  display: flex;
  align-items: center;
  justify-content: center;
  ${space}
`;

export const StyledLine = styled.div<SpaceProps & { lineColor: string }>`
  height: 1px;
  flex: 1;
  background-color: ${({ theme, lineColor }): string =>
    lineColor || theme.colors.line};
  ${space}
`;

export const StyledRowTitle = styled.div<TypographyProps & ColorProps>`
  font-size: ${({ theme }) => theme.fontSizes[2]};
  color: ${({ theme }): string => theme.colors.normalText};
  ${typography}
  ${color}
`;

export const StyledRowValue = styled.div`
  font-size: ${({ theme }) => theme.fontSizes[2]};
  color: ${({ theme }): string => theme.colors.secondaryText};
`;
